export enum ZIndex {
  Topmost = 2147483647,
  Modal = 40,
  Tooltip = 30,
  Header = 20,
  SecondaryNavigation = 10,
}
